import { PieceSlider, PieceDescription, PieceUnorderedList } from '@store/index';
const PUBLIC_URL = process.env.REACT_APP_URL;

const golfWeb = {
    name: 'Golf Web App',
    slug: 'golf-web',
    description: 'Startup project that helps to organize the real golf playing game between players in better order. Gather statistics about players. Big Data real time processing. iPhone/iPad/Web/IoT interfaces.',
    cover: {
        url: `${PUBLIC_URL}/portfolio/golf-web/cover.jpg`,
        license: {
            link: 'http://www.freepik.com',
            text: 'Designed by photoangel / Freepik'
        }
    },
    prominentColor: 'rgb(200,222,129)',
    pieces: [
        {
            type: 'slider',
            images: [
                {
                    url: `${PUBLIC_URL}/portfolio/golf-web/tournament.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by vectorpouch / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/golf-web/course.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/golf-web/club.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by Bedneyimages / Freepik'
                    }
                },{
                    url: `${PUBLIC_URL}/portfolio/golf-web/cover.jpg`,
                    license: {
                        link: 'http://www.freepik.com',
                        text: 'Designed by photoangel / Freepik'
                    }
                }
            ]
        } as PieceSlider,
        {
            type: 'description',
            title: 'Role',
            description: 'Full-Stack developer',
        } as PieceDescription,
        {
            type: 'unordered list',
            title: 'Main Technologies',
            items: ['JAVA', 'Spring', 'Postgres', 'Angular', 'Big Data'],
        } as PieceUnorderedList,
    ],
}

export default golfWeb;


// WEBPACK FOOTER //
// ./src/store/portfolio/golf-web.tsx